import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { getPageUrl } from "utils/getPageUrl";
import { Container } from "components";
import { Flex, Heading, Button } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { ArrowRightIcon } from "styles/icons";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import type { CTABarProps } from "./CTABar.d";

export const CTABar = ({ heading, buttonText }: SbEditableComponentProps<CTABarProps>) => {
  const translations = useTranslations();
  const language = useLanguage();

  return (
    <Container>
      <Flex
        maxW={MAX_GRID_WIDTH}
        bg="primary.500"
        justify="space-between"
        alignItems="center"
        rounded="lg"
        mx={4}
        p={6}
        direction={{ base: "column", md: "row" }}
      >
        <Heading as="h3" variant="h3" py={4} fontWeight="bold" color="white" pt={0} pb={{ base: 4, md: 0 }}>
          {heading || translations("how_do_i_know")}
        </Heading>
        <Button
          as="a"
          href={getPageUrl(language, "webappNewClaim")}
          variant="subtle"
          color="primary.500"
          size="m"
          width={{ base: "full", md: "initial" }}
          sx={{ svg: { boxSize: 4 } }}
        >
          {buttonText || translations("check_compensation")}
          <ArrowRightIcon ml={2} />
        </Button>
      </Flex>
    </Container>
  );
};
